import { ConfigHelper } from '../constants'
import { IException } from '../models'
import { ClientStorage } from '../storage'

export const handleException = (exception: any): IException => {
  if (exception.message === 'Network Error') {
    return {
      code: 'network_error',
      description: 'Bağlantı Hatası!',
    }
  }

  if (exception.response !== undefined) {
    if (exception.response.status > 399 && exception.response.status < 500) {
      if (exception.response.status === 404) {
        const res: IException = {
          code: 'not_found',
          description: 'API Bulunamadı!',
          isTokenExpired: false,
          httpStatusCode: exception.response.status,
        }

        return res
      }

      // if (exception.response.status === 401) {
      //   if (exception.response.data) {
      //     return {
      //       code: "unauthorized_access",
      //       description: exception.response.data.Message,
      //       httpStatusCode: exception.response.data.Code,
      //     };
      //   }

      //   return {
      //     code: "unauthorized_access",
      //     description: "You are not authorized for this request!",
      //     httpStatusCode: exception.response.status,
      //   } as IException;
      // }

      if (exception.response.status === 403) {
        const res: IException = {
          code: 'forbidden_access',
          description: exception.response.data?.Message
            ? exception.response.data?.Message
            : 'Bu Bağlantı İçin Yetkiniz Bulunmamaktadır!',
          httpStatusCode: exception.response.status,
          reason: exception.response.data?.Reason,
        }

        return res
      }

      if (exception.response.status === 401 || exception.response.status === 430) {
        const res: IException = {
          code: 'unauthorized_access',
          description: "Oturum Süreniz Dolmuştur!",
          // description: exception.response.data?.Message,
          httpStatusCode: exception.response.status,
          reason: exception.response.data?.Reason,
        }

        return res
      }

      if (!exception.response.data) {
        const res: IException = {
          code: '',
          description: '',
          isTokenExpired: false,
          httpStatusCode: exception.response.status,
        }

        return res
      }

      const response: IException = {
        code:
          exception.response.data[0] === undefined || exception.response.data[0].code === undefined
            ? ''
            : exception.response.data[0].code,
        description:
          exception.response.data[0] === undefined || exception.response.data[0].description === undefined
            ? ''
            : exception.response.data[0].description,
        httpStatusCode: exception.response.status,
        isTokenExpired: false,
      }

      return response
    }

    if (exception.response.status > 499) {
      return {
        code: 'internal_server_error',
        description: 'Beklenmeyen bir hata oluştu!',
      }
    }
  }

  return exception
}

export const encrypt = (password: string): string => {
  const bytes = new TextEncoder().encode(password)

  let binary = ''
  bytes.forEach(byte => {
    binary += String.fromCharCode(byte)
  })

  return btoa(binary)
}

export const clearLoginStorage = () => {
  ClientStorage.removeItem(ConfigHelper.INDEXPAZAR_USER_TOKEN)
  ClientStorage.removeItem(ConfigHelper.INDEXPAZAR_USER_REFRESH_TOKEN)
  ClientStorage.removeItem(ConfigHelper.INDEXPAZAR_USER_TOKEN_CREATE_TIME)
  ClientStorage.removeItem(ConfigHelper.INDEXPAZAR_USER_DATA)
}
